import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGoal } from '../context/GoalContext';
import Header from '../components/Header';
import AccountCard from '../components/AccountCard';
import Button from '../components/Button';
import styles from './CreateGoal.module.css';

const accounts = [
  { id: 1, name: 'Everyday Savings', number: '4892', balance: 3210 },
  { id: 2, name: 'Checking', number: '1180', balance: 1840 },
  { id: 3, name: 'Travel Fund', number: '7723', balance: 420 }
];

const CreateGoalStep3 = () => {
  const navigate = useNavigate();
  const { goal, setGoal, saveGoal } = useGoal();
  const [selectedId, setSelectedId] = useState(goal.accountId || null);

  const handleCreate = () => {
    const updated = { ...goal, accountId: selectedId };
    setGoal(updated);
    const saved = saveGoal(updated);
    navigate('/create-goal/confirmation', { state: { goalId: saved.id } });
  };

  return (
    <div className={styles.screen}>
      <Header title="New goal" />

      <div className={styles.progress}>
        <div className={styles.progressTrack}>
          <div className={styles.progressFill} style={{ width: '75%' }} />
        </div>
        <span className={styles.progressLabel}>3 of 4</span>
      </div>

      <div className={styles.body}>
        <h2 className={styles.heading}>Which account?</h2>
        <p className={styles.sub}>Choose where your savings will come from.</p>

        <div className={styles.accountList} role="radiogroup" aria-label="Select account">
          {accounts.map(account => (
            <AccountCard
              key={account.id}
              account={account}
              selected={selectedId === account.id}
              onSelect={setSelectedId}
            />
          ))}
        </div>
      </div>

      <div className={styles.footer}>
        <Button label="Create goal" onClick={handleCreate} disabled={!selectedId} />
      </div>
    </div>
  );
};

export default CreateGoalStep3;
